import React,{useState,useEffect} from 'react'
import { Card, CardHeader, CardBody, Row, Col, Button, Container, CardImg,Modal, ModalHeader, ModalBody} from "reactstrap";
import { fetchOnlineSalesReport } from 'network/ApiAxiosCeleApp';
import Chart from 'chart.js';
import { Bar } from "react-chartjs-2";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import Header from 'components/Headers/Header';

function OnlineSalesByDateReport() {
    const [startDate, setStartDate] = useState(new Date(new Date().toISOString().split('T')[0] + 'T00:00:00.000Z'));
    const [endDate, setEndDate] = useState(new Date(new Date().toISOString().split('T')[0] + 'T23:59:59.000Z'));
    const [reportResp, setReportResp] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalSales, setModalSales] = useState([]);
    const [eventName, setEventName] = useState('');

    const toggle = () => setModal(!modal);

    useEffect(() => {
      getReport()
    }, []);

    const role = JSON.parse(localStorage.getItem("user")).role

    const onDateChange = (dates) => {
        const [start, end] = dates;
        console.log(start.toISOString().split('T')[0] + '00:00:00.000Z') 
        setStartDate(start);
        setEndDate(end);
      };

    const getReport = async()=>{
        if(!startDate || !endDate) return
        const resp = await fetchOnlineSalesReport(startDate,endDate)
        if(resp.data){
          setReportResp(resp.data)
          console.log(resp.data)
        }
    }

    const getBigPurchase = (orders)=>{
        let avrgTickets = 0
        let bigOrder = orders.map((orderItem)=>{
            avrgTickets == 0 ? avrgTickets = orderItem.qt : avrgTickets = (avrgTickets + orderItem.qt) / 2
            return orderItem.qt
        })
        avrgTickets = bigOrder.reduce((a, b) => a + b, 0) / bigOrder.length;
        avrgTickets = (Math.round(avrgTickets * 100) / 100).toFixed(2);
        bigOrder = Math.max(...bigOrder)
        return {bigOrder,avrgTickets}
    }

    const openReport = (sales,name)=>{
        setModalSales(sales)
        setEventName(name)
        toggle()
    }

    const makeDataDayTotals = (data)=>{
        return {
          labels: data.map((dataItem)=>Object.keys(dataItem)[0]),
          datasets: [
            {
              label: eventName,
              data: data.map((dataItem)=>Object.values(dataItem)[0]),
              maxBarThickness: 10,
            },
          ],
        }
    }
    const options = {
        scales: {
            yAxes:[{ticks:{
                beginAtZero: true,
                stepSize:1
            }}]
        },
        responsive: true,
      };

  return (
    <>
        {role == 'admin' && <Header/>}
        <Container>
        <Row>
            <DatePicker onChange={onDateChange} startDate={startDate} endDate={endDate} selectsRange withPortal placeholderText="Select a date" calendarStartDay={1} className='ml-2 mt-3'/>
            <Button className='ml-2' onClick={() => getReport()} > Go</Button>
        </Row>
            <Row>
                {reportResp.length > 0 && reportResp.map((eventItem)=>{
                    return <Col className="mb-2" xl="6" key={eventItem.id}>
                        <Card className='shadow'>
                            <CardHeader className="border-0 text-center">
                                <Row className="text-center">
                                    <Col>
                                        <h3 className="mt-6">{eventItem.name} </h3>
                                    </Col>
                                    <Col>
                                        <CardImg style={{borderRadius: "150px"}} alt="Card image cap" src={eventItem.picture} top width="3%" />
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <p><b> Date: </b>{eventItem.eventDate}</p>
                                        <p><b>Tickets Sold: </b> {eventItem.ticketsSold}</p>
                                        <p><b>Average Purchase Days: </b> {(Math.round(eventItem.dayAverage * 100) / 100).toFixed(2)}</p>
                                        <p><b>Biggest Purchase: </b> {getBigPurchase(eventItem.orders).bigOrder}</p>
                                        <p><b>Average Purchase Amount: </b> {getBigPurchase(eventItem.orders).avrgTickets}</p>
                                    </Col>
                                    <Col className=' d-flex justify-content-center text-center'>
                                        <Button className=' btn-info' onClick={()=>openReport(eventItem.salesByDate,eventItem.name)}>Open Report</Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                })}
            </Row>
        </Container>

        <Modal isOpen={modal} toggle={toggle} size='lg'>
            <ModalHeader>{eventName}</ModalHeader>
            <ModalBody>
                {console.log(makeDataDayTotals(modalSales))}
                <Bar data={makeDataDayTotals(modalSales)} options={options} />
            </ModalBody>
        </Modal>
    </>
  )
}

export default OnlineSalesByDateReport